function ContactUs() {
  return (
    <div
      style={{
        background: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "40px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "1000px",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #111, #191919)",
          border: "1px solid #222",
          borderRadius: "22px",
          padding: "28px",
          marginBottom: "24px",
        }}
      >
        <h1 style={{ marginTop: 0 }}>Contact Us</h1>
        <p style={{ color: "#d1d1d1", lineHeight: "1.8", marginBottom: 0 }}>
          Reach MistriBazaar for support, platform issues, bookings, materials, or business onboarding.
        </p>
      </div>

      <div
        style={{
          background: "#111",
          border: "1px solid #222",
          borderRadius: "18px",
          padding: "24px",
        }}
      >
        <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
          <strong>Email:</strong> support@mistribazaar.com
        </p>
        <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
          <strong>Phone:</strong> +91 90000 00000
        </p>
        <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
          <strong>Support Hours:</strong> 9:00 AM to 8:00 PM
        </p>
        <p style={{ color: "#d1d1d1", lineHeight: "1.8", marginBottom: 0 }}>
          You can also raise support requests from future dashboard-based support tools.
        </p>
      </div>
    </div>
  );
}

export default ContactUs;